import moment from "moment";
import format from "string-template";
import { DATE_FORMAT } from "utils/constants";
import * as yup from "yup";

const validation = (messages, { deltaStart }) => {
  const requiredString = yup
    .string()
    .typeError(messages.REQUIRED)
    .required(messages.REQUIRED);

  return yup.object().shape({
    project: yup.object().shape({
      ria: yup.boolean().optional(),
      contact: yup.object().shape({
        socioProfessionalCategory: requiredString,
        acceptContact: yup
          .boolean()
          .required(messages.REQUIRED)
          .oneOf([true], messages.REQUIRED),
        user: yup.object().shape({
          birthDate: yup
            .date()
            .typeError(messages.REQUIRED)
            .required(messages.REQUIRED)
            .max(moment().subtract(18, "years").endOf("year"), messages.AGE_18)
            .min(
              moment().subtract(100, "year").startOf("year"),
              messages.AGE_99,
            ),
        }),
      }),
      contract: yup.object().shape({
        issuanceDate: yup
          .date()
          .typeError(messages.REQUIRED)
          .min(
            moment().startOf("day").add(deltaStart, "days"),
            format(messages.MIN_DATE, {
              date: moment().add(deltaStart, "days").format(DATE_FORMAT),
            }),
          )
          .required(messages.REQUIRED),
      }),
    }),
  });
};

export default validation;
